import React, { useContext } from 'react'
import deepmerge from 'deepmerge'
import { navigate } from 'gatsby'

const LOG_KEY = '[@kogk/gatsby-plugin-i18n]'

const LangContext = React.createContext({
  translations: {},
  availableLanguages: [],
  language: null
})

const mergeReplace = (_, sourceArray) => sourceArray

export const LanguageProvider = ({ data, children }) => {
  const existingData = useContext(LangContext)

  if (data.language) {
    data.language = data.language.substring(0, 2)
  }

  const merged = deepmerge(existingData, data, {
    arrayMerge: mergeReplace
  })

  if (
    merged.language &&
    merged.availableLanguages.indexOf(merged.language) === -1
  ) {
    console.error(
      `${LOG_KEY} language '${data.language}' not found in ` +
        `availableLanguages (${existingData.availableLanguages.join(', ')})`
    )

    navigate('/404')
  }

  return <LangContext.Provider value={merged}>{children}</LangContext.Provider>
}

const processTplLiteral = (arr, ...vars) => {
  return arr.map((str, i) => str + (vars[i] ?? '')).join('')
}

export const useLanguage = () => {
  const { language, translations, availableLanguages } = useContext(LangContext)

  return {
    language,
    availableLanguages,
    t: (...args) => {
      const [key] = args
      // This is an array when t is called as a template literal
      const str = Array.isArray(key) ? processTplLiteral(...args) : key

      const parts = str.split('|')

      if (parts.length < 2) {
        parts.unshift('default')
      }

      const [group, name] = parts

      try {
        const translated = translations[language][group][name]

        if (typeof translated === 'undefined') {
          throw new KeyNotFoundError()
        }

        return translated
      } catch (error) {
        if (error instanceof TypeError || error instanceof KeyNotFoundError) {
          logNotFound(str, language)

          return str
        } else {
          throw error
        }
      }
    }
  }
}

const logNotFound = (str, language) => {
  // lets try to not clutter the console with lots of these, if not found
  const key = `${str},${language}`
  if (process.env.NODE_ENV === 'production') {
    if (seen[key]) {
      return
    }

    seen[key] = true
  }

  console.warn(`${LOG_KEY} No translation for ${str} in language ${language}`)
}

export const langCompare = (a, b) => {
  const [ta, tb] = [typeof a, typeof b]
  if (ta !== tb || ta !== 'string') {
    return false
  }

  return a.substring(0, 2) === b.substring(0, 2)
}

const seen = {}

class KeyNotFoundError extends Error {}
